import React from 'react';
import { useI18n } from '@whizz/react-i18n';
import type { ClassReportType, HighlightedProps } from '../../types';
import { student_status_groups } from '../../types';
import { ProgressConsistencyGroup } from '../../../components';
import { SectionLayout } from '../modules';
import type { AllColorType } from '../../../util/types';

type Props = {
  classReport: ClassReportType
  showOthersData: boolean
  chartIsExpanded?: boolean
} & HighlightedProps;

const StudentStatus = (
  {
    classReport,
    highlightedIds,
    showOthersData,
    chartIsExpanded,
    onElementClick,
  }: Props,
): JSX.Element => {
  const { translate } = useI18n();

  let students = [ ...classReport.students.all ];

  if (!showOthersData) {
    students = students.filter((student) => highlightedIds?.includes(student.id));
  }

  return (
    <SectionLayout
      title={translate('pages.REPORTS.SECTIONS.STUDENT_STATUS.title')}
      value={showOthersData ? classReport.studentStatusAverage : null}
      moreInfo={translate('pages.REPORTS.SECTIONS.STUDENT_STATUS.info')}
      className={'pdf-no-break'}
      data-cy="student-status"
      hideAverage
      chartIsExpanded={chartIsExpanded}
      overrideColor={showOthersData ? classReport.studentStatusAverage as AllColorType : null}
      id='student-status-container'
    >
      <div className={'md:grid grid-cols-5 grid-flow-row'}
        data-cy='student-status-chart'>
        {student_status_groups.map((group) => (
          <ProgressConsistencyGroup
            key={`student_status_${group}`}
            headline={translate(`pages.REPORTS.STUDENT_STATUS.${group}`)}
            background={group}
            students={students.filter((student) => student.studentStatus === group)}
            highlightedIds={highlightedIds}
            showOthersData={showOthersData}
            onElementClick={onElementClick}
          />
        ))}
      </div>
    </SectionLayout>
  );
};

StudentStatus.displayName = 'StudentStatus';

export default StudentStatus;
